import { FC } from 'react'

import usePasswordVerifyBlock from '$actions/usePasswordVerifyForm'
import {
  description as descriptionStyle,
  header,
  title as titleStyle
} from '$blocks/common/auth.css'
import PasswordVerifyForm from '$hook-forms/PasswordVerifyForm'

export type PasswordVerifyBlockProps = ReturnType<typeof usePasswordVerifyBlock>

export const PasswordVerifyBlock: FC<PasswordVerifyBlockProps> = ({
  title,
  description,
  ...props
}) => {
  return (
    <>
      <header className={header}>
        <h2 className={titleStyle}>{title}</h2>

        <p className={descriptionStyle}>{description}</p>
      </header>

      <PasswordVerifyForm {...props} />
    </>
  )
}

export default PasswordVerifyBlock
